import { DiscountObject } from "@/app/api/orders/route";
import serverAxiosInstance from "@/app/middleware/serverAxiosInstance";
import {
  OrderStatus,
  SummerCampDiscount,
  ONE_MODULES,
  CommonConstant,
  SECONDRY_SMS_GATEWAY_API_KEY,
  Gender,
  APP_NAME,
  ENV,
  OLYMPIA_MODULES,
  ClassificationTypes,
  VenueType,
} from "./enum";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import axiosInstance from "@/service/axiosInstance";
import { VivaCartItem } from "@/redux/features/vivaCartSlice";
import { MDMEndpoints } from "./endpoints";
import { FeeDescriptionMap } from "./feeDescriptionMap";

const jose = require("jose");
const jwt = require("jsonwebtoken");

export const animationCreate = () => {
  if (typeof window !== "undefined") {
    import("wowjs").then((module) => {
      const WOW = module.default;
      new WOW.WOW({ live: false }).init();
    });
  }
};

export async function getTotalPrice(
  values: [],
  discountObjects: DiscountObject[],
) {
  let total_event_fee = 0;
  let pre_discounted_price = 0;

  const promises = values.map(async (element: any) => {
    const { eventId } = element;
    // console.log('element :>> ', element);
    const evenetLength = element.groups.length;

    let { data } = await serverAxiosInstance.get(
      MDMEndpoints.VIVA_ACTIVITY_MASTERS,
      {
        params: {
          sort: "createdAt:desc",
          "populate[0]": "fees_id",
          "filters[id][$eq]": eventId,
        },
      },
    );

    const curData = data.data[0];
    // console.log("inside utilss");

    let { is_gst_applicable, sac_code, fee_amount_for_period } =
      curData.attributes.fees_id.data.attributes;
    // console.log("inside utilss");

    let cgst_rate = 0;
    let sgst_rate = 0;

    if (is_gst_applicable) {
      const gst = await serverAxiosInstance.get(
        `${MDMEndpoints.FC_SAC_MASTERS}/${sac_code}`,
      );

      if (gst.status == 200) {
        cgst_rate = gst.data.data?.attributes.CGST_Rate;
        sgst_rate = gst.data.data?.attributes.SGST_UTGST_Rate;
      }
      fee_amount_for_period +=
        ((cgst_rate + sgst_rate) / 100) * fee_amount_for_period;
    }

    pre_discounted_price =
      pre_discounted_price + fee_amount_for_period * evenetLength;

    const discountObj = discountObjects.find((doc) => doc.eventId == eventId);

    if (discountObj && discountObj.eventId == eventId) {
      if (discountObj.type == CommonConstant.PERCENTAGE) {
        fee_amount_for_period =
          fee_amount_for_period -
          (discountObj.value / 100) * fee_amount_for_period;
      } else {
        fee_amount_for_period = fee_amount_for_period - discountObj.value;
      }
    }

    total_event_fee = total_event_fee + fee_amount_for_period * evenetLength;
  });

  await Promise.all(promises);
  return { total_event_fee, pre_discounted_price };
}
export const correctUrlString = (imageString: any): string[] => {
  if (typeof imageString !== "string" || !imageString.trim()) return [];

  try {
    const parsed = JSON.parse(imageString.trim());

    if (Array.isArray(parsed)) {
      // Clean and validate each URL
      return parsed
        .map((url) =>
          typeof url === "string"
            ? url.trim().replace(/^,|,$/g, "") // remove leading/trailing commas
            : "",
        )
        .filter(
          (url) =>
            url && (url.startsWith("http://") || url.startsWith("https://")),
        );
    } else {
      console.error("Parsed JSON is not an array:", parsed);
      return [];
    }
  } catch (error) {
    console.error("JSON Parsing Error in correctUrlString:", error);
    return [];
  }
};

export const getAcademicYearOptions = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const isAfterApril = today.getMonth() >= 3;
  // console.log("🚀 ~ getAcademicYearOptions ~ isAfterApril:", today.getMonth())
  const startYear = 2024; // Fixed start year
  const endYear = isAfterApril ? currentYear : currentYear - 1;

  const options = [];
  for (let year = startYear; year <= endYear; year++) {
    options.push({
      value: year.toString(),
      label: `${year}-${year + 1}`,
    });
  }
  return options;
};

export function getSortedSectionsWRTpage(data: any, section: any, page: any) {
  return data
    .filter(
      (item: any) =>
        item.attributes.Section === section && item.attributes.Page === page,
    )
    .sort((a: any, b: any) => a.attributes.Sequence - b.attributes.Sequence)
    .map((item: any) => ({
      id: item.id,
      section: item.attributes.Section,
      page: item.attributes.Page,
      type: item.attributes.Type,
      Title: item.attributes.Title,
      URL: item.attributes.URL,
      content: item.attributes.Content,
      Image_Path: item.attributes.Image_Path,
      sequence: item.attributes.Sequence,
      academicYear: item.attributes.ac_academic_year.data?.attributes.name,
    }));
}

export function getSortedWRTpage(data: any, page: any) {
  return data
    .filter((item: any) => item?.attributes?.Page === page)
    .sort((a: any, b: any) => a?.attributes?.Sequence - b?.attributes?.Sequence)
    .map((item: any) => ({
      id: item?.id,
      Section: item?.attributes?.Section,
      Page: item?.attributes?.Page,
      Type: item?.attributes?.Type,
      Title: item?.attributes?.Title,
      URL: item?.attributes?.URL,
      content: item?.attributes?.Content,
      Image_Path: item?.attributes?.Image_Path,
      sequence: item?.attributes?.Sequence,
      academicYear: item?.attributes?.ac_academic_year?.data?.attributes?.name,
    }));
}

export function getSortedSectionsWRTType(data: any, section: any, type: any) {
  return data
    .filter(
      (item: any) =>
        item.attributes.Section === section && item.attributes.Type === type,
    )
    .sort((a: any, b: any) => a.attributes.Sequence - b.attributes.Sequence)
    .map((item: any) => ({
      id: item.id,
      section: item.attributes.Section,
      page: item.attributes.Page,
      type: item.attributes.Type,
      Title: item.attributes.Title,
      URL: item.attributes.URL,
      content: item.attributes.Content,
      Image_Path: item.attributes.Image_Path,
      sequence: item.attributes.Sequence,
    }));
}

export const kebabCase = (string: any) => {
  // Check if the input is not a string, return an empty string or handle it as needed
  if (typeof string !== "string") {
    return "";
  }

  string = string.replace(/[^a-zA-Z0-9]+/g, " ");
  // Split the text into words
  const words = string.trim().split(/\s+/);
  // Join the words with hyphens
  const kebabCase = words.join("-").toLowerCase();

  return kebabCase;
};

export const groupkebabCase = (value: any) => {
  if (typeof value !== "string") return "";

  let str = value.toLowerCase();
  str = str.replace(/[{}]/g, "");
  str = str.replace(/[^a-z0-9]+/g, "-");
  str = str.replace(/-+/g, "-");
  str = str.replace(/^-|-$/g, "");
  return str;
};

export const deKebabCase = (string: any) => {
  if (typeof string !== "string") return "";

  // Replace hyphens with spaces
  string = string.replace(/-/g, " ");

  // Trim extra spaces
  return string.trim(); // Keep case as is
};

export const formatDateRange = (startDate: any, endDate: any) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Check if the dates are valid
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return "--";
  }

  const months: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (!endDate || start.getTime() === end.getTime()) {
    const startDay = start.getDate();
    const startMonth = months[start.getMonth()];
    const startYear = start.getFullYear().toString().substr(2);
    return `${startDay} ${startMonth} '${startYear}`;
  }
  const startDay = start.getDate();
  const startMonth = months[start.getMonth()];
  const startYear = start.getFullYear().toString().substr(2);
  const endDay = end.getDate();
  const endMonth = months[end.getMonth()];
  const endYear = end.getFullYear().toString().substr(2);

  return `${startDay} ${startMonth} '${startYear}- ${endDay} ${endMonth} '${endYear}`;
};

export const signJWS = async (payload: any) => {
  const encoder = new TextEncoder();
  const key = encoder.encode(process.env.BILLDESK_SECRET_KEY);

  const jws = await new jose.SignJWT(payload)
    .setProtectedHeader({
      alg: "HS256",
      clientid: process.env.BILLDESK_CLIENT_ID,
    })
    .sign(key);

  return jws;
};
export const signPaymentLinkJWS = async (payload: any) => {
  const encoder = new TextEncoder();
  const key = encoder.encode(process.env.BILLDESK_PAYMENTLINK_SECRET_KEY);

  const jws = await new jose.SignJWT(payload)
    .setProtectedHeader({
      alg: "HS256",
      clientid: process.env.BILLDESK_PAYMENT_LINK_CLIENT_ID,
    })
    .sign(key);

  return jws;
};
export const convertToISTTimeString = (date: any) => {
  const timestamp = new Date(date);
  timestamp.setMinutes(timestamp.getMinutes() + 330);

  const formattedTimestamp = timestamp.toISOString().slice(0, -5) + "+05:30";
  return formattedTimestamp;
};

export const decodeJWS = async (token: any) => {
  const decoded = jwt.decode(token, { complete: true });
  return decoded.payload;
};

export const amountToWords = (amount: any) => {
  const singleDigits = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function convertTwoDigit(n: number): string {
    if (n < 10) return singleDigits[n];
    else if (n < 20) return teens[n - 10];
    else {
      const ten = Math.floor(n / 10);
      const unit = n % 10;
      return tens[ten] + (unit ? "-" + singleDigits[unit] : "");
    }
  }

  function convertThreeDigit(n: number): string {
    const hundred = Math.floor(n / 100);
    const rest = n % 100;
    let result = "";

    if (hundred > 0) {
      result += singleDigits[hundred] + " Hundred";
      if (rest > 0) result += " And ";
    }

    if (rest > 0) {
      result += convertTwoDigit(rest);
    }

    return result;
  }

  if (amount === 0) {
    return "Zero Rupees Only";
  }

  const integerPart = Math.floor(amount);
  const fractionalPart = Math.round((amount - integerPart) * 100);

  const crore = Math.floor(integerPart / 1e7);
  const lakh = Math.floor((integerPart % 1e7) / 1e5);
  const thousand = Math.floor((integerPart % 1e5) / 1e3);
  const hundred = integerPart % 1000;

  let result = "";

  if (crore > 0) {
    result += convertThreeDigit(crore) + " Crores";
  }

  if (lakh > 0) {
    if (result) result += " ";
    result += convertThreeDigit(lakh) + " Lakhs";
  }

  if (thousand > 0) {
    if (result) result += " ";
    result += convertThreeDigit(thousand) + " Thousand";
  }

  if (hundred > 0) {
    if (result) result += " ";
    result += convertThreeDigit(hundred);
  }

  result += " Rupees";

  if (fractionalPart > 0) {
    result += " And " + convertTwoDigit(fractionalPart) + " Paisa";
  }

  result += " Only";

  return result;
};

export const calculateAge = (dob: any) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

// export const generateUniqueNumber = (lob_segment_id: any) => {
//   // Get the current epoch time in milliseconds
//   const currentTime = Date.now(); // returns the current timestamp in milliseconds

//   // Convert the currentTime to a base 36 string
//   let uniqueNumber = currentTime.toString(36).toUpperCase();

//   // Ensure the length is exactly 11 characters by padding with zeros if necessary
//   while (uniqueNumber.length < 11) {
//     uniqueNumber = "0" + uniqueNumber;
//   }

//   // Trim the uniqueNumber to 11 characters if it exceeds
//   uniqueNumber = uniqueNumber.slice(-11);

//   return uniqueNumber;
// };

// export const generateUniqueNumbers = async (lob_segment_id: any) => {
//   await connectDB();
//   // Get the current epoch time in milliseconds
//   const currentTime = Date.now();
//   const currentYearFull = new Date(currentTime).getFullYear();
//   const currentYearShort = currentYearFull.toString().slice(-2);

//   // const resp = await Utils.create({ receipt_count: 0 });

//   // Convert the currentTime to a base 36 string
//   const result = await Utils.findOneAndUpdate(
//     { lob_segment_id },
//     [
//       {
//         $set: {
//           receipt_count: {
//             $cond: [
//               { $not: ["$receipt_count"] }, // Check if receipt_count doesn't exist
//               "00001", // If it doesn't exist, set to '00001'
//               {
//                 $toString: {
//                   $sum: [{ $toInt: "$receipt_count" }, 1],
//                 },
//               }, // Else, increment by 1
//             ],
//           },
//         },
//       },
//       {
//         $set: {
//           receipt_count: {
//             $substr: [
//               {
//                 $concat: [
//                   {
//                     $cond: [
//                       { $lt: [{ $strLenCP: "$receipt_count" }, 5] },
//                       {
//                         $substr: [
//                           "00000",
//                           0,
//                           { $subtract: [5, { $strLenCP: "$receipt_count" }] },
//                         ],
//                       },
//                       "",
//                     ],
//                   },
//                   "$receipt_count",
//                 ],
//               },
//               0,
//               5,
//             ],
//           },
//         },
//       },
//     ],
//     { upsert: true, returnDocument: "after" } // Ensure the updated document is returned
//   );

//   const receiptCount = result?.receipt_count?.toString().padStart(5, "0");

//   let uniqueID = lob_segment_id + currentYearShort + receiptCount;

//   // // Ensure the length is exactly 11 characters by padding with zeros if necessary
//   // while (uniqueNumber.length < 11) {
//   //   uniqueNumber = "0" + uniqueNumber;
//   // }

//   // // Trim the uniqueNumber to 11 characters if it exceeds
//   // uniqueNumber = uniqueNumber.slice(-11);

//   return uniqueID;
// };

export const syncStatus = (status: any) => {
  if ([OrderStatus.DRAFT, OrderStatus.ACTIVE].includes(status)) {
    return {
      status: "Proccesing",
      color: "grey",
      backgroundColor: "#ffffb3",
    };
  } else if (status == OrderStatus.FAILED) {
    return {
      status: "Failed",
      color: "#FF0000",
      backgroundColor: "red",
    };
  } else {
    return {
      status: "Success",
      color: "white",
      backgroundColor: "rgb(6, 194, 112)",
    };
  }
};

export const validateToken = (token: string) => {
  const secretKey: any = process.env.LOGIN_SECRET_KEY;
  return jwt.verify(token, secretKey);
};

export const fornatPriceIntoIndianFormat = (price: any) => {
  let numStr = price?.toString();
  let [integerPart, decimalPart] = numStr.split(".");
  let lastThree = integerPart.slice(-3);
  let otherNumbers = integerPart.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  let formattedIntegerPart =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return decimalPart
    ? formattedIntegerPart + "." + decimalPart
    : formattedIntegerPart;
};

export const formatAgeForUi = (
  age_from: number | null,
  age_to: number | null,
) => {
  if (age_from != null && age_to != null) {
    return age_from > 1 ? `${age_from}-${age_to}` : `Under ${age_to}`;
  } else if (age_to != null) {
    return `${age_to} yrs`;
  } else {
    return `${age_from} & Above`;
  }
};
export const formatGradeForUi = (age_from: number, age_to: number) => {
  if (age_to - age_from > 3) {
    return `${age_from} - ${age_to}`;
  } else {
    return Array(age_to - age_from + 1)
      .fill(age_from)
      .map((x, y) => x + y)
      .join(", ");
  }
};

export const removeUUIDFromFilename = (filename: string) => {
  return filename?.replace(/^[a-f0-9\-]{36}-/, "");
};

export const convertToEmbededURL = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const videoId = match && match[2].length === 11 ? match[2] : null;
  return `https://www.youtube.com/embed/${videoId}`;
};

export const makeDummyDiscountObjects = (formData: any) => {
  return formData
    ? formData.map(() => ({ type: "", value: 0, eventId: 0 }))
    : [{ type: "", value: 0, eventId: 0 }];
};

export function isOnlineEventVideoSubmitClose(dateString: string | null) {
  if (!dateString) {
    return false;
  }
  let inputDate = new Date(dateString);
  inputDate.setHours(23, 59, 59, 999);
  let currentDate = new Date();
  return currentDate >= inputDate;
}

export function convertDateFormat(dateString: string) {
  const [day, month, year] = dateString.split("/");

  return `${year}-${month}-${day}`;
}

export function formatRegistrationDates(start: string, end: string) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long" };

  const formattedStartDate = startDate.toLocaleDateString("en-GB", options);
  const formattedEndDate = endDate.toLocaleDateString("en-GB", options);

  if (
    startDate.getDate() === endDate.getDate() &&
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getFullYear() === endDate.getFullYear()
  ) {
    return formattedStartDate;
  } else {
    return `${formattedStartDate} to ${formattedEndDate}`;
  }
}

export const createDateWithTime = (
  hour: number,
  minute: number,
  seconds: number,
) => {
  const date = new Date();
  date.setHours(hour);
  date.setMinutes(minute);
  date.setSeconds(seconds);
  date.setMilliseconds(0);
  return date;
};

export const formatTimeInTable = (time: string) => {
  if (time) {
    const [hrs, mins] = time.split(":");
    return `${hrs}:${mins}`;
  } else {
    return "-";
  }
};

export const calculatePrice = (
  selectedEvents: Array<any>,
  setFieldValue?: any,
) => {
  let price = 0;
  let discountEvents = 0;
  let discountValue = 1;

  selectedEvents.forEach((event) => {
    const basePrice = event.event.attributes.event_fee;
    price += basePrice;

    if (event.event.attributes.is_discount) {
      discountEvents += 1;
    }
  });

  discountValue = SummerCampDiscount[discountEvents];

  if (discountEvents > 4) discountValue = SummerCampDiscount[4];
  if (discountEvents === 0) discountValue = SummerCampDiscount[1];

  const updatedEvents = selectedEvents.map((event) => {
    const basePrice = event.event.attributes.event_fee;

    let paidFee = basePrice;

    if (event.event.attributes.is_discount) {
      paidFee = basePrice - basePrice * discountValue;
    }

    return {
      ...event,
      event: {
        ...event.event,
        attributes: {
          ...event.event.attributes,
          paid_fee: paidFee,
        },
      },
    };
  });
  const discountPrice = updatedEvents.reduce((sum, event) => {
    return sum + event.event.attributes.paid_fee;
  }, 0);

  if (setFieldValue) {
    setFieldValue("selectedEvents", updatedEvents);
  }

  return { price, discountPrice, updatedEvents };
};

export const convertTo12HourFormat = (time: string) => {
  return dayjs(time, "HH:mm").format("hh:mm A");
};

export const stringTotitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const commonSelectStyles = () => ({
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: "#3F41D1",
    boxShadow: state.isFocused ? `0 0 0 1px ${"#3F41D1"}` : provided.boxShadow,
    "&:hover": {
      borderColor: "#3F41D1",
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#3F41D1"
      : state.isFocused
        ? "#f3f4f6"
        : "white",
    color: state.isSelected ? "white" : "black",
  }),
});

export function mapToVivaCartItem(rawData: any): VivaCartItem {
  const source = rawData?.attributes ? rawData?.attributes : rawData;
  return {
    ...source,
    id: source?.id || "",
    group_name: source?.group_name || "",
    sub_type:
      source?.fees_sub_type?.data?.attributes?.name || source["Sub Type"] || "",
    Category:
      source?.fees_category?.data?.attributes?.name || source?.Category || "",
    fc_fees_type_id:
      source?.fees_description?.data?.id || source?.fc_fees_type_id,
    school_id: source?.school?.data?.id || source?.school_id,
    image_link: source?.image_link,
    isPrivate: source?.is_private,
    host_school_name: source?.host_school_name || source?.venue_name,
    venue_name: source?.venue_name || "",
    is_private: source?.is_private || false,
    inCart: 0,
  };
}

export const getWeightOptions = (events: any) => {
  return events
    .filter(
      (e: any) =>
        e.attributes.weight_from != null && e.attributes.weight_to != null,
    )
    .sort(
      (a: any, b: any) => a.attributes.weight_from - b.attributes.weight_from,
    )
    .map((e: any) => ({
      label: `${e.attributes.weight_from}-${e.attributes.weight_to} kg`,
      value: `${e.attributes.weight_from}-${e.attributes.weight_to}`,
      from: e.attributes.weight_from!,
      to: e.attributes.weight_to!,
    }));
};

export const getAgeOptions = (events: any[]) => {
  const seen = new Map<
    string,
    { label: string; value: number; ageText: string; boardDateStr: string }
  >();

  events
    .filter(
      (e: any) =>
        e.attributes.Board_on_or_after !== undefined &&
        e.attributes.Board_on_or_after !== null &&
        e.attributes.Board_on_or_after !== "" &&
        e.attributes.age_to !== undefined &&
        e.attributes.age_to !== null,
    )
    .forEach((e: any) => {
      const boardDateStr = e.attributes.Board_on_or_after;
      const ageTo = e.attributes.age_to;
      const ageFrom = e.attributes.age_from;
      if (!seen.has(boardDateStr)) {
        const ageText =
          ageFrom != null && ageTo != null
            ? ageFrom > 1
              ? `${ageFrom} - ${ageTo} ${ageTo === 1 ? "year" : "years"}`
              : `Under ${ageTo} ${ageTo === 1 ? "year" : "years"}`
            : ageTo != null
              ? `${ageTo} ${ageTo === 1 ? "year" : "years"}`
              : `${ageFrom} ${ageFrom === 1 ? "year" : "years"} & Above`;

        seen.set(boardDateStr, {
          label: `${ageText} (Born on or after ${boardDateStr})`,
          value: ageTo,
          ageText,
          boardDateStr,
        });
      }
    });

  return Array.from(seen.values()).sort((a, b) => a.value - b.value); // Sort by age_to ascending
};
export const getGradeOptions = (events: any[]) => {
  const seen = new Map<
    string,
    { label: string; value: string; from: string; to: string }
  >();

  events
    .filter(
      (e: any) =>
        e.attributes.Grade_From?.data?.attributes?.name &&
        e.attributes.Grade_To?.data?.attributes?.name,
    )
    .forEach((e: any) => {
      const fromGrade = e.attributes.Grade_From.data.attributes;
      const toGrade = e.attributes.Grade_To.data.attributes;

      const fromCalc =
        e.attributes.Grade_From.data.attributes.Calculation_Value;
      const toCalc = e.attributes.Grade_To.data.attributes.Calculation_Value;

      const key = `${fromCalc}_${toCalc}`;
      console.log("🚀 ~ getGradeOptions ~ key:", key);

      if (!seen.has(key)) {
        const label =
          fromCalc == toCalc
            ? `${fromGrade.name}`
            : `${fromGrade.name} to ${toGrade.name}`;
        console.log("🚀 ~ getGradeOptions ~ label:", label);

        seen.set(key, {
          label,
          value: key,
          from: fromGrade.name,
          to: toGrade.name,
        });
      }
    });

  return Array.from(seen.values()).sort((a, b) => {
    const aFrom = parseInt(a.value.split("_")[0]);
    const bFrom = parseInt(b.value.split("_")[0]);
    return aFrom - bFrom;
  });
};

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const mapParticipant = (
  formData: any,
  eventId: string,
  participantOverrides = {},
) => ({
  dateOfBirth: "",
  enrollmentNumber: formData.enrollmentNumber,
  eventId: String(eventId),
  firstName: formData.firstName,
  gender: formData.gender?.value,
  grade: formData.grade,
  lastName: formData.lastName,
  schoolName: formData.schoolName?.label
    ?.toUpperCase()
    .replaceAll(",", "-")
    .trim(),
  otherSchoolName: formData.otherSchoolName,
  mobileNumber: formData.phoneNumber,
  url: formData.url,
  studentType: formData.studentType?.value,
  email: formData.email,
  tshirtSize: formData.tshirt,
  ...participantOverrides, // e.g., passportNumber for `gi`
});

export const buildEventGroup = (
  event: any,
  formData: any,
  participantOverrides = {},
) => ({
  groupNo: 1, // or dynamically passed if needed
  minimum_entry: event.attributes.minimum_entry,
  maximum_entry: event.attributes.maximum_entry,
  gender: event.attributes.gender,
  category: event.attributes.fees_sub_type?.data?.attributes?.name || "",
  fees_description:
    event.attributes.fees_description?.data?.attributes?.name || "",
  fees_sub_type: event.attributes.fees_sub_type?.data?.attributes?.name || "",
  fees_sub_category:
    event.attributes.fees_sub_category?.data?.attributes?.name || "",
  period_of_service:
    event.attributes.period_of_service?.data?.attributes?.name || "",
  title: event.attributes.title,
  venue_name: event.attributes.venue_name,
  image_link: event.attributes.image_link,
  event_start_date: event.attributes.event_start_date,
  event_end_date: event.attributes.event_end_date,
  event_register_start_date: event.attributes.event_register_start_date,
  event_register_end_date: event.attributes.event_register_end_date,
  event_fee: event.attributes.event_fee * 100,
  pre_discounted_event_fee: event.attributes.preDiscounted_event_fee
    ? event.attributes.preDiscounted_event_fee * 100
    : undefined,
  participants: [mapParticipant(formData, event.id, participantOverrides)],
  participantCount: 1,
  video_urls: "",
});

export const buildEventStructure = (
  event: any,
  formData: any,
  participantOverrides = {},
) => ({
  eventId: event.id,
  fees_id: event.attributes.fees_description?.data?.id,
  fees_category: event.attributes.fees_category?.data?.id,
  type:
    event.attributes.minimum_entry >= 1 && event.attributes.maximum_entry > 1
      ? ClassificationTypes.GROUP
      : ClassificationTypes.INDIVIDUAL,
  participation_type: event.attributes.participation_type,
  time_from: event.attributes.time_from,
  time_to: event.attributes.time_to,
  groups: [buildEventGroup(event, formData, participantOverrides)],
});

export const updateDataStructureByModule = (
  formData: any,
  module: any,
): any => {
  const participantOverrides: any = {};

  if ([ONE_MODULES.GI, ONE_MODULES.VAFS].includes(module)) {
    participantOverrides.passportNumber = formData.passportNumber;
  }
  console.log(formData, "formDataformData");

  const selectedEventStructures = formData?.map(
    (selectedEvent: any, i: number) => {
      console.log(selectedEvent, "selecteedevhbhds");

      const event = selectedEvent.event || selectedEvent;
      const eventStructure = buildEventStructure(
        event,
        formData,
        participantOverrides,
      );

      // Override groupNo for summercamp/psa
      if ([ONE_MODULES.SUMMER_CAMP, ONE_MODULES.VSPA].includes(module)) {
        eventStructure.groups[0].groupNo = i + 1;
      }

      return eventStructure;
    },
  );

  // For modules with `pendingEvents`, handle separately
  if ([ONE_MODULES.GI, ONE_MODULES.VAFS].includes(module)) {
    const pendingEventStructures = formData.pendingEvents.map((event: any) =>
      buildEventStructure(event, formData, participantOverrides),
    );

    return {
      updatedDataStructureAccordingToDB: selectedEventStructures,
      updatedPendingDataStructureAccordingToDB: pendingEventStructures,
    };
  }

  return selectedEventStructures;
};

export const getCartItemKey = (item: any): string => {
  return `${item.group_name}_${item.sub_type}_${item.venue_name || "NA"}_${item.age || "NA"}_${item.gender || "NA"}`;
};

export const isMatch = (doc: any, criteria: any) => {
  return Object.entries(criteria).every(([key, value]) => {
    if (value === null || value === undefined) {
      return true; // skip null/undefined matchCriteria
    }
    // doc must have the key and value must match exactly
    return doc.hasOwnProperty(key) && doc[key] === value;
  });
};
export const getSendOtpUrl = (phoneNumber: string, otp: string): string => {
  const baseUrl = process.env.SECONDRY_SMS_GATEWAY_API_URL;
  const params = new URLSearchParams({
    APIKey:
      process.env.SECONDRY_SMS_GATEWAY_API_KEY || SECONDRY_SMS_GATEWAY_API_KEY,
    senderid: "VIBSMS",
    channel: "2",
    DCS: "0",
    flashsms: "0",
    number: phoneNumber,
    text: `Hi ${otp} is your OTP to login to your VIVA Account On ${phoneNumber}. OTP Valid for 5min -VIBGYOR`,
    route: "49",
  });

  return `${baseUrl}?${params.toString().replace(/\+/g, "%20")}`;
};
export const calculateBulkUploadTotalFee = (
  csvData: any[],
  eventData: any[],
  isGroupEvent: boolean,
): number => {
  let totalAmount = 0;

  if (isGroupEvent) {
    const groupCounts: {
      [key: string]: { count: number; participants: any[] };
    } = {};

    csvData?.forEach((participant: any) => {
      const groupNumber = participant?.groupNumber;
      if (groupCounts[groupNumber]) {
        groupCounts[groupNumber].count++;
        groupCounts[groupNumber].participants.push(participant);
      } else {
        groupCounts[groupNumber] = {
          count: 1,
          participants: [participant],
        };
      }
    });

    const groupSummary = Object.entries(groupCounts).map(
      ([groupName, info]) => ({
        groupName,
        count: info.count,
      }),
    );

    if (eventData?.length) {
      totalAmount = eventData[0]?.attributes?.event_fee * groupSummary.length;
    }
  } else {
    totalAmount = csvData?.reduce((acc: number, participant: any) => {
      const event = eventData.find((e: any) => e.id === participant.eventId);
      return acc + (event?.attributes?.event_fee || 0);
    }, 0);
  }

  return totalAmount;
};

export const toRoman = (num: number): string => {
  const romanMap: Record<number, string> = {
    1: "I",
    2: "II",
    3: "III",
    4: "IV",
    5: "V",
    6: "VI",
    7: "VII",
    8: "VIII",
    9: "IX",
    10: "X",
    11: "XI",
    12: "XII",
  };
  return romanMap[num] || `${num}`;
};

type FormValues = {
  formData: {
    groups: {
      participants: Record<string, any>[];
    }[];
  }[];
};

export function updateNestedParticipantValue(
  values: FormValues,
  index: number,
  groupIndex: number,
  partIndex: number,
  key: string,
  newValue: any,
): FormValues {
  return {
    ...values,
    formData: values.formData.map((item, idx) =>
      idx === index
        ? {
            ...item,
            groups: item.groups.map((group, gIdx) =>
              gIdx === groupIndex
                ? {
                    ...group,
                    participants: group.participants.map((participant, pIdx) =>
                      pIdx === partIndex
                        ? {
                            ...participant,
                            [key]: newValue,
                          }
                        : participant,
                    ),
                  }
                : group,
            ),
          }
        : item,
    ),
  };
}
export const supportedFormats = [
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "MM-DD-YYYY",
  "MM/DD/YYYY",
  "D-M-YYYY",
  "D/M/YYYY",
  "YYYY/MM/DD",
  "DD/MM/YY",
  "MM-YYYY",
];
export const normalizeDob = (dateOfBirth: string) => {
  if (!dateOfBirth) return undefined;
  const dob = dayjs(dateOfBirth, supportedFormats, true);
  if (!dob.isValid()) return undefined;
  return dob.format("YYYY-MM-DD");
};
export const calculateAgeBulkupload = (dateOfBirth: string) => {
  const normalized = normalizeDob(dateOfBirth);
  if (!normalized) return undefined;

  const dob = dayjs(normalized, "YYYY-MM-DD");
  return dayjs().diff(dob, "years");
};
const romanToArabicMap: any = {
  "LITTLE ADVENTURERS": -4,
  PLAYSCHOOL: -4,
  "LITTLE EXPLORERS": -3,
  NURSERY: -3,
  "LITTLE DISCOVERERS": -2,
  "JR.KG": -2,
  "LITTLE ENQUIRERS": -1,
  "SR.KG": -1,
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  V: 5,
  VI: 6,
  VII: 7,
  VIII: 8,
  IX: 9,
  X: 10,
  XI: 11,
  XII: 12,
};

export const fromRoman = (roman: string) => {
  const value = romanToArabicMap[roman.trim().toUpperCase()];
  return value !== undefined ? value : null;
};

const gradeLabelToValueMap: any = {
  "LITTLE ADVENTURERS": -4,
  PLAYSCHOOL: -4,
  "LITTLE EXPLORERS": -3,
  NURSERY: -3,
  "LITTLE DISCOVERERS": -2,
  "JR.KG": -2,
  "LITTLE ENQUIRERS": -1,
  "SR.KG": -1,
  "GRADE I": 1,
  "GRADE II": 2,
  "GRADE III": 3,
  "GRADE IV": 4,
  "GRADE V": 5,
  "GRADE VI": 6,
  "GRADE VII": 7,
  "GRADE VIII": 8,
  "GRADE IX": 9,
  "GRADE X": 10,
  "GRADE XI": 11,
  "GRADE XII": 12,
  "AS LEVEL": 11,
  "A LEVEL": 12,
};

export const normalizeGrade = (input: string | number) => {
  if (typeof input === "number") return input;

  const cleaned = input?.trim().toUpperCase();

  if (!cleaned) return null;
  if (gradeLabelToValueMap[cleaned]) {
    return gradeLabelToValueMap[cleaned];
  }
  const noPrefix = cleaned.replace(/^GRADE\s*/, "");
  if (romanToArabicMap[noPrefix]) {
    return romanToArabicMap[noPrefix];
  }
  const parsed = parseInt(noPrefix);
  if (!isNaN(parsed)) return parsed;

  return null;
};

export const normalizeGender = (gender: string) => {
  const cleaned = gender?.trim().toLowerCase();
  if (["m", Gender.male].includes(cleaned)) return Gender.male;
  if (["f", Gender.female].includes(cleaned)) return Gender.female;
  return undefined;
};

export const getAdminDetailsByMobilenumber = async (
  mobilenumber: string,
): Promise<any | null> => {
  try {
    const public_token = process.env.NEXT_PUBLIC_API_TOKEN;
    const { data } = await axiosInstance.get(`/user/${mobilenumber}`, {
      headers: {
        "x-api-token": `Bearer ${public_token}`,
      },
    });
    return data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    return null;
  }
};

export const fetchGrades = async () => {
  try {
    const { data } = await axiosInstance.get("/grade");
    let structuredGradeData: any[] = [];
    for (let i = 0; i < data.length; i++) {
      structuredGradeData.push({
        label: data[i]?.attributes?.name,
        value: data[i]?.attributes?.Calculation_Value,
        order: data[i]?.attributes?.order,
      });
    }
    structuredGradeData.sort((a: any, b: any) => a.order - b.order);
    return structuredGradeData;
  } catch (error: any) {
    console.log("Error in loading grades :>> ", error.data || error);
    return [];
  }
};

export const formatDateToYYYYMMDD = (input: any) => {
  if (!input) return null;
  if (typeof input !== "string") return null;

  let date = new Date(input);
  if (!isNaN(date.getTime())) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const match = input.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
  if (match) {
    const [, day, month, year] = match;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return null;
};

type Environment = ENV.prod | ENV.uat | ENV.dev;
type AppKey =
  | APP_NAME.VIBGYOR_VIVA
  | APP_NAME.VIBGYOR_ONE
  | APP_NAME.SUMMER_CAMP_PRIVATE;

export function getModuleFromCart(cart: any[]): string | undefined {
  if (!cart.length) return undefined;

  const feeId = cart[0]?.attributes?.fees_description?.data?.id;
  if (feeId === undefined) return undefined;

  const appName = process.env
    .NEXT_PUBLIC_APP_NAME as keyof typeof FeeDescriptionMap;
  const rawEnv =
    (process.env.NEXT_PUBLIC_ENV?.toLowerCase() as ENV) || ENV.prod;
  const env: Environment = [ENV.prod, ENV.uat, ENV.dev].includes(rawEnv)
    ? (rawEnv as Environment)
    : ENV.uat;

  const feeMap = FeeDescriptionMap[appName]?.[env];
  if (!feeMap) return undefined;

  const moduleKey = Object.keys(feeMap).find((key) => feeMap[key] === feeId);

  if (
    moduleKey &&
    appName == APP_NAME.VIBGYOR_ONE &&
    Object.values(ONE_MODULES).includes(moduleKey as ONE_MODULES)
  ) {
    return moduleKey as ONE_MODULES;
  }
  if (
    moduleKey &&
    appName == APP_NAME.SUMMER_CAMP_PRIVATE &&
    Object.values(OLYMPIA_MODULES).includes(moduleKey as OLYMPIA_MODULES)
  ) {
    return moduleKey as OLYMPIA_MODULES;
  }

  return undefined;
}

export const generatePdf = async (
  receiptHtml: string,
  filename = "receipt.pdf",
) => {
  const html2pdf = (await import("html2pdf.js")).default;
  console.log("generating pdf");

  const element = document.createElement("div");
  element.innerHTML = receiptHtml;

  const opt = {
    filename,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false,
      allowTaint: true,
      letterRendering: true,
      scrollY: 0,
    },
    jsPDF: { unit: "in", format: "a3", orientation: "landscape" },
  };

  const pdfUrl = await html2pdf().from(element).set(opt).outputPdf("bloburl");

  return pdfUrl;
};

export const getVenueTypeOptions = (
  events: any[],
  campType: string,
  duration: any,
  grade?: any,
  gender?: any,
) => {
  console.log("🚀 ~ getVenueTypeOptions ~ campType:", campType);
  if (!events || events.length === 0 || !campType) {
    return [];
  }

  let filteredEvents = events.filter(
    (event) => event.attributes.logic_name === campType,
  );

  if (duration && duration?.startDate) {
    filteredEvents = filteredEvents.filter((event) => {
      const eventStartDate =
        event.attributes.fees_id.data.attributes.activity_start_date;
      const eventEndDate =
        event.attributes.fees_id.data.attributes.activity_end_date;

      return (
        eventStartDate === duration.startDate &&
        eventEndDate === duration.endDate
      );
    });
  }
  console.log("🚀 ~ getVenueTypeOptions ~ filteredEvents:", filteredEvents);

  filteredEvents = filteredEvents.filter((event) => {
    console.log("🚀 ~ getVenueTypeOptions ~ event:", event);
    let isGradeMatch = true;
    let isGenderMatch = true;

    if (grade?.value !== undefined && grade?.value !== null) {
      const eventGradeFrom =
        event.attributes.Grade_From?.data?.attributes?.Calculation_Value;
      console.log("🚀 ~ getVenueTypeOptions ~ eventGradeFrom:", eventGradeFrom);
      const eventGradeTo =
        event.attributes.Grade_To?.data?.attributes?.Calculation_Value;
      console.log("🚀 ~ getVenueTypeOptions ~ eventGradeTo:", eventGradeTo);
      const normalizedGrade = Number(grade.value);
      console.log(
        "🚀 ~ getVenueTypeOptions ~ normalizedGrade:",
        normalizedGrade,
      );

      if (
        eventGradeFrom !== undefined &&
        eventGradeTo !== undefined &&
        !isNaN(normalizedGrade)
      ) {
        isGradeMatch =
          normalizedGrade >= eventGradeFrom && normalizedGrade <= eventGradeTo;
        console.log("🚀 ~ getVenueTypeOptions ~ isGradeMatch:", isGradeMatch);
      } else {
        // If event has no grade range, treat as not matching
        isGradeMatch = false;
      }
    }

    if (gender) {
      const eventGender = event.attributes.gender?.toLowerCase();
      console.log("🚀 ~ getVenueTypeOptions ~ eventGender:", eventGender);
      const normalizedGender = gender.value?.toLowerCase();
      console.log(
        "🚀 ~ getVenueTypeOptions ~ normalizedGender:",
        normalizedGender,
      );
      isGenderMatch =
        normalizedGender && eventGender
          ? eventGender === normalizedGender || eventGender === "all"
          : false;
      console.log("🚀 ~ getVenueTypeOptions ~ isGenderMatch:", isGenderMatch);
    }

    return isGradeMatch && isGenderMatch;
  });
  console.log("🚀 ~ getVenueTypeOptions ~ filteredEvents:", filteredEvents);

  if (filteredEvents.length === 0) {
    return [];
  }

  const venueMap = {
    funfinity: false,
    indoor: false,
    outdoor: false,
    indoorDayCamp: false,
    outdoorDayCamp: false,
    dayCamp: false,
    indoorHalfCamp: false,
    halfCampKids: false,
    halfCamp: false,
    generic: false,
  };

  filteredEvents.forEach((event) => {
    const title = event.attributes.title?.toLowerCase().trim() || "";

    if (title.includes("indoor day camp (kids)")) {
      venueMap.indoorDayCamp = true;
    } else if (title.includes("outdoor day camp (kids)")) {
      venueMap.outdoorDayCamp = true;
    } else if (title.includes("indoor half day camp (kids)")) {
      venueMap.indoorHalfCamp = true;
    } else if (title.includes("half day camp (kids)")) {
      venueMap.halfCampKids = true;
    } else if (title.includes("half day camp")) {
      venueMap.halfCamp = true;
    } else if (title.includes("day camp")) {
      venueMap.dayCamp = true;
    } else if (title.includes("funfinity")) {
      venueMap.funfinity = true;
    } else if (title.includes("indoor")) {
      venueMap.indoor = true;
    } else if (title.includes("outdoor")) {
      venueMap.outdoor = true;
    } else {
      venueMap.generic = true;
    }
  });

  const options = [];

  if (venueMap.generic) {
    options.push({ label: "All", value: VenueType.All });
  }

  if (venueMap.dayCamp) {
    options.push({
      label: "Summer Funfinity- Day Camp",
      value: VenueType.DayCamp,
    });
  }

  if (venueMap.outdoorDayCamp) {
    options.push({
      label: "Summer Funfinity- Outdoor Day Camp (Kids)",
      value: VenueType.OutdoorDayCamp,
    });
  }

  if (venueMap.indoorDayCamp) {
    options.push({
      label: "Summer Funfinity- Indoor Day Camp (Kids)",
      value: VenueType.IndoorDayCamp,
    });
  }
  if (venueMap.indoorHalfCamp) {
    options.push({
      label: "Summer Funfinity- Indoor Half Day Camp (Kids)",
      value: VenueType.IndoorHalfCamp,
    });
  }

  if (venueMap.halfCampKids) {
    options.push({
      label: "Summer Funfinity- Half Day Camp (Kids)",
      value: VenueType.HalfCampKids,
    });
  }

  if (venueMap.halfCamp) {
    options.push({
      label: "Summer Funfinity- Half Day Camp",
      value: VenueType.HalfCamp,
    });
  }
  if (venueMap.funfinity) {
    options.push({ label: "Funfinity", value: VenueType.Funfinity });
  }

  if (venueMap.indoor) {
    options.push({ label: "Indoor", value: VenueType.Indoor });
  }

  if (venueMap.outdoor) {
    options.push({ label: "Outdoor", value: VenueType.Outdoor });
  }

  // console.log("🚀 ~ getVenueTypeOptions ~ options:", options);
  return options;
};
